import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from "@jem-open/jem-ui";

type CloseAnnouncementModalProps = {
  open: boolean;
  isClosing?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const CloseAnnouncementModal: React.FC<CloseAnnouncementModalProps> = ({ open, isClosing, onClose, onConfirm }) => (
  <Dialog open={open} onOpenChange={(o: boolean) => { if (!o && !isClosing) onClose(); }}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Close announcement</DialogTitle>
        <DialogDescription>
          Are you sure you want to close this announcement? It will no longer be visible to employees.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="outline" disabled={isClosing}>Cancel</Button>
        </DialogClose>
        <Button
          className="bg-red-500 hover:bg-red-600"
          onClick={onConfirm}
          disabled={isClosing}
        >
          {isClosing ? "Closing..." : "Close Announcement"}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default CloseAnnouncementModal;
